const NOVEMBER = 10;
const THURSDAY = 4;

// US Thanksgiving: the fourth Thursday of November, which always falls on the 22nd to the 28th.
export function isThanksgivingDay(date: Date): boolean {
  return date.getMonth() === NOVEMBER && date.getDay() === THURSDAY && date.getDate() >= 22 && date.getDate() <= 28;
}
